import { ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';
import background from 'assets/images/tutorialbg.png';

const Container = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <Flex
      height="100%"
      justifyContent="center"
      alignItems="center"
      backgroundImage={`url(${background})`}
    >
      <Flex
        height="100%"
        width="100%"
        bg="custom.levoWhite50"
        sx={{
          backdropFilter: 'blur(81.5485px)',
        }}
        justifyContent="center"
        alignItems="center"
      >
        <Flex
          position="relative"
          direction="column"
          height={['100%', '80%', '70%', '70%']}
          width={['100%', '80%', '70%', '70%']}
          bg="custom.levoOffWhite"
          boxShadow="0px 0px 4px 4px rgba(0, 0, 0, 0.25)"
          overflow="auto"
        >
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Container;
